import { render, staticRenderFns } from "./AdminSetOpeningBalance.vue?vue&type=template&id=2a2b901a&"
import script from "./AdminSetOpeningBalance.vue?vue&type=script&lang=js&"
export * from "./AdminSetOpeningBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports